import Cookies from 'js-cookie'
import { NEXT_LOCALE_COOKIE } from 'shared/constants/cookies'
import { normalizeLocale } from 'shared/i18n/normalize-locale'

const ONE_YEAR_IN_DAYS = 365

const COOKIE_OPTIONS: Cookies.CookieAttributes = {
  path: '/',
  sameSite: 'Lax',
  expires: ONE_YEAR_IN_DAYS,
}

export const setLocaleCookie = (locale?: string) => {
  if (typeof document === 'undefined') return

  const normalized = normalizeLocale(locale) || locale
  if (!normalized) return

  Cookies.set(NEXT_LOCALE_COOKIE, normalized, COOKIE_OPTIONS)
}
